// @flow
import React from 'react';
import Icon from '@waglabs/icon';
import Flex from '@waglabs/flex';
import Link from '@waglabs/link';

type Props = {
  iconWidth?: string,
};

const icons = [
  {
    name: 'facebook',
    url: 'https://facebook.com/wagwalking',
  },
  {
    name: 'instagram',
    url: 'https://instagram.com/wag',
  },
  {
    name: 'twitter',
    url: 'https://twitter.com/wagwalking',
  },
];

const SocialMediaIcons = ({
  iconWidth,
}: Props) => (
  <Flex
    p={3}
    justifyContent="center"
  >
    { icons.map(icon => (
      <Link
        key={icon.name}
        href={icon.url}
        target="_blank"
      >
        <Icon
          name={icon.name}
          mx={2}
          hover
          width={iconWidth}
        />
      </Link>
    ))}
  </Flex>
);

SocialMediaIcons.defaultProps = {
  iconWidth: 'auto',
};

export default SocialMediaIcons;
